import React, { useContext, useEffect, useState } from 'react'
import { Layout, Row, Col, Spin } from "antd";
import { LoadingOutlined } from '@ant-design/icons';
import { NavView } from '../../components/NavView';
import { AppContext, useApiContext } from '../../util/context';
import { MenuTab } from '../../components/MenuTab';
import { Cache } from 'aws-amplify/utils';
import { listHZDCardsCreatedBy, listHZDCardsWCBusinessUnit, listHZDCardsWCBusinessUnitQhsseUsers, listHazardActionsByAssignedToTeam } from '../../util/myQueries';
import './Home.css'
import { HazardHomeView } from '../../components/Home/Hazards/HazardHomeView';
import ErrorBoundary from '../../util/ErrorBoundary';
import { cleanDepartment } from '../../util/details';
import { QhsseUsers, businessUnitRemappings } from '../../util/details';

const { Content } = Layout;

export const HomeView = ({appProps}) => {
    const { StyledDiv, userData} = useContext(AppContext);
    const { client } = useApiContext();
    const [data, setData] = useState([]);
    const [current, setCurrent] = useState('mycards');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [isFirstVisit, setIsFirstVisit] = useState(false);
    const [allActions, setAllActions] = useState([]);

    async function getAllCreatedCards() {
        const fullName = userData.given_name + ' ' + userData.family_name;
        let allItems = [];
        let nextToken = null;
        do {
          const response = await client.graphql({
            query: listHZDCardsCreatedBy,
            variables: {
              createdBy: fullName,
              limit: 300,
              nextToken,
            },
          });

          const data = response.data.listHazards;
          allItems = [...allItems, ...data.items];
          nextToken = data.nextToken;
        } while (nextToken);
        return allItems;
    }

    async function getAllQhsseUsersCards() {
        let allItems = [];
        let nextToken = null;
        do {
            const response = await client.graphql({
                query: listHZDCardsWCBusinessUnitQhsseUsers,
                variables: {
                    limit: 300,
                    nextToken,
                },
            });
            const data = response.data.listHazards;
            allItems = [...allItems, ...data.items];
            nextToken = data.nextToken;
        } while (nextToken);

        return allItems;
        
    }

    async function getAllBusinessUnitCards() {
        const businessUnit = cleanDepartment(userData['custom:Department']);
        let allItems = [];
        let nextToken = null;
        do {
            const response = await client.graphql({
                query: listHZDCardsWCBusinessUnit,
                variables: {
                    businessUnit: businessUnit,
                    limit: 300,
                    nextToken,
                },
            });
            const data = response.data.listHazards;
            allItems = [...allItems, ...data.items];
            nextToken = data.nextToken;
        } while (nextToken);

        return allItems;
    }

    async function getAllBusinessUnitCardsMapping(MappingValue) {
        let allItems = [];
        let nextToken = null;
        do {
            const response = await client.graphql({
                query: listHZDCardsWCBusinessUnit,
                variables: {
                    businessUnit: MappingValue,
                    limit: 300,
                    nextToken,
                },
            });
            const data = response.data.listHazards;
            allItems = [...allItems, ...data.items];
            nextToken = data.nextToken;
        } while (nextToken);

        return allItems;
    }
    
    async function getAllAssignedActionsToTeam() {
        let allItems = [];
        let nextToken = null;
        const businessUnit = cleanDepartment(userData['custom:Department']);
        do {
            const response = await client.graphql({
                query: listHazardActionsByAssignedToTeam,
                variables: {
                    businessUnit: businessUnit,
                    limit: 300,
                    nextToken,
                },
            });
            const data = response.data.listHazardActions;
            allItems = [...allItems, ...data.items];
        } while (nextToken);
        return allItems;
    }
    

    useEffect(() => {
        let mounted = true;

        if(mounted && userData){

            const removeCacheHS = async () => {
                await Cache.removeItem('mycardshs');
                await Cache.removeItem('teamcardshs');
                await Cache.removeItem('assignedactionstoteam');
            };
            removeCacheHS();
            setIsFirstVisit(true);
            
        }

        return () => {
            mounted = false;
        }; 

    }, [userData]);
    
    useEffect(() => {
        let mounted = true;
    
        const fetchData = async () => {
            const myCachedCards = await Cache.getItem('mycardshs');
            const teamCachedCards = await Cache.getItem('teamcardshs');
            const assignedActionsCached = await Cache.getItem('assignedactionstoteam');

            try {
                const fullName = userData.given_name + ' ' + userData.family_name;

                const businessUnit = cleanDepartment(userData['custom:Department']);
                let cards = [];
                let actions = [];
        
                if (current === 'mycards') {
                    if (myCachedCards) {

                        cards = myCachedCards;
                    } else {
                        /* if(fullName === "Dillon Raymond") {
                            cards = await getAllCreatedCards();
                        } else {
                            const tempCards = await client.graphql({
                                query: listHZDCardsCreatedBy,
                                variables: { createdBy: fullName, limit: 1000 },
                            });
                            cards = tempCards.data.listHazards.items;
                        } */
                        cards = await getAllCreatedCards();
                        await Cache.setItem('mycardshs', cards, {
                            expires: 3600000 + Date.now()
                        });
                    }
                }
        
                if (current === 'myteamscards') {
                    if (teamCachedCards) {
                        cards = teamCachedCards;
                    } else {
                        /* if(fullName === "Dillon Raymond") {
                            if(QhsseUsers.has(userData.email.toLowerCase())){
                                cards = await getAllQhsseUsersCards();
                            }else{
                                const mapping = businessUnitRemappings.find(
                                    b => b.unit === cleanDepartment(businessUnit)
                                );
                                if(mapping){
                                    cards = await getAllBusinessUnitCardsMapping(mapping.value);
                                }else{
                                    cards = await getAllBusinessUnitCards();
                                }
                            }
                        }else{
                            if(QhsseUsers.has(userData.email.toLowerCase())){
                                const qhsseCards = await client.graphql({
                                    query: listHZDCardsWCBusinessUnit,
                                    variables: { businessUnit: "QHSSE", limit: 1000 },
                                });
    
                                const hsseCards = await client.graphql({
                                    query: listHZDCardsWCBusinessUnit,
                                    variables: { businessUnit: "HSSE", limit: 1000 },
                                });
    
                                cards = [...qhsseCards.data.listHazards.items, ...hsseCards.data.listHazards.items];
                            }else{
                                const mapping = businessUnitRemappings.find(
                                    b => b.unit === cleanDepartment(businessUnit)
                                );
                                if(mapping){
                                    const tempCards = await client.graphql({
                                        query: listHZDCardsWCBusinessUnit,
                                        variables: { businessUnit: mapping.value, limit: 1000 },
                                    });
                                    cards = tempCards.data.listHazards.items;
                                }else{
                                    const tempCards = await client.graphql({
                                        query: listHZDCardsWCBusinessUnit,
                                        variables: { businessUnit: cleanDepartment(businessUnit), limit: 1000 },
                                    });
                                    cards = tempCards.data.listHazards.items;
                                }
                            }
                        } */

                        if(QhsseUsers.has(userData.email.toLowerCase())){
                            cards = await getAllQhsseUsersCards();
                        }else{
                            const mapping = businessUnitRemappings.find(
                                b => b.unit === cleanDepartment(businessUnit)
                            );
                            if(mapping){
                                cards = await getAllBusinessUnitCardsMapping(mapping.value);
                            }else{
                                cards = await getAllBusinessUnitCards();
                            }
                        }

                        await Cache.setItem('teamcardshs', cards, {
                            expires: 3600000 + Date.now()
                        });
                    }
                }

                if (current === 'assignedactionstoteam') {
                    if (assignedActionsCached) {
                        actions = assignedActionsCached;
                    }else{

                        actions = await getAllAssignedActionsToTeam();
                        await Cache.setItem('assignedactionstoteam', actions, {
                            expires: 3600000 + Date.now()
                        });
                    }
                }
        
                if (cards) {
                    const combinedCards = cards.map((card) => {
                        const actions = card.actions.items;
                        return {
                            ...card,
                            actions: actions,
                        };
                    });
        
                    if (mounted) {
                        setData(combinedCards);
                    }
                }

                if(actions && actions.length > 0) {
                    const allActions = [];
                    actions.forEach((action) => {
                        action.dateObserved = action.Hazard.dateObserved;
                        action.HZDID = action.Hazard.HZDID;
                        action.location = action.Hazard.location;
                        action.createdBy = action.Hazard.createdBy;
                        allActions.push(action);
                    });
                    setAllActions(allActions);
                }
                
            } catch (error) {
                console.log('Error fetching data:', error);
                if (mounted) setError(true);
            } finally {
                if (mounted) setLoading(false);
            }
            
        };
    
        if (mounted && userData && isFirstVisit) {
            setLoading(true)
            fetchData();
        }
    
        return () => {
          mounted = false;
        };
    }, [userData, current, isFirstVisit]);

    return (
        <Layout className="layout">
            <Content style={{ padding: "0", backgroundColor: "white" }}>
                <NavView landing={false} selection="home" appProps={appProps}/>

                <Row>
                    <Col
                        span={2}
                        className="homeHazardMenu"
                    >
                        <MenuTab location="home" appProps={appProps} StyledDiv={StyledDiv} />
                    </Col>

                    <Col
                        xl={{span: 22}}
                        lg={{span: 24}}
                        md={{span: 24}}
                        sm={{span: 24}}
                        xs={{span: 24}}
                        style={{
                            height: "91dvh",
                            marginTop: "9dvh"
                        }}
                    >
                        {loading && (
                            <Row
                                style={{
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                                    <Spin indicator={<LoadingOutlined style={{ fontSize: 50 }} spin />} spinning={loading}></Spin>
                                </div>
                            </Row>
                        )}

                        {error && (
                            <Row
                                style={{
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    className="errorText"
                                ><StyledDiv>Data fetch failed, please try again later.</StyledDiv></div>
                            </Row>
                        )}

                        {!loading && !error && <>
                            <ErrorBoundary>
                                <HazardHomeView 
                                    data={
                                        current === 'assignedactionstoteam' ? allActions : data
                                    } 
                                    client = {client} 
                                    current = {current} 
                                    setCurrent = {setCurrent}
                                />
                            </ErrorBoundary>
                            
                        </>}
                    </Col>
                </Row>
            </Content>
        </Layout>
    )
}
